export default __webpack_public_path__ + "static/media/add.a55976e8.svg";